import { formatDateYYYYMMDD, isValidDate } from './validator';

/**
 * Build gift card line item properties object according to the Shopify schema.
 * When the shopify digital gift card product is added to the cart and completed the purchase
 *  then the gift card notificaiotn emails are sent to the recipient and buyer
 *
 * Shopify Doc: https://shopify.dev/docs/storefronts/themes/product-merchandising/gift-cards#create-a-form-to-collect-recipient-information
 *
 */
const GIFT_CART_RECIPIENT_FLAG_ATTRIBUTE = '__shopify_send_gift_card_to_recipient';
const GIFT_CART_RECIPIENT_EMAIL_ATTRIBUTE = 'Recipient email';
const GIFT_CART_RECIPIENT_NAME_ATTRIBUTE = 'Recipient name';
const GIFT_CART_MESSAGE_ATTRIBUTE = 'Message';
const GIFT_CART_SEND_ON_ATTRIBUTE = 'Send on';
const GIFT_CART_OFFSET_ATTRIBUTE = '__shopify_offset';

/**
 * Default values for Digital Gift Card recipient fields
 */
const GIFT_CART_RECIPIENT_FLAG_ON = 'on';
const GIFT_CART_OFFSET_DEFAULT = '180';

export const buildGiftCardLineItemProperties = ({
  emailRecipient,
  messageRecipient,
  nameRecipient,
  sendOn,
}) => {
  return {
    [GIFT_CART_MESSAGE_ATTRIBUTE]: messageRecipient,
    [GIFT_CART_RECIPIENT_EMAIL_ATTRIBUTE]: emailRecipient,
    [GIFT_CART_RECIPIENT_FLAG_ATTRIBUTE]: GIFT_CART_RECIPIENT_FLAG_ON,
    [GIFT_CART_RECIPIENT_NAME_ATTRIBUTE]: nameRecipient,
    ...(isValidDate(sendOn) && { [GIFT_CART_SEND_ON_ATTRIBUTE]: formatDateYYYYMMDD(sendOn) }),
    [GIFT_CART_OFFSET_ATTRIBUTE]: GIFT_CART_OFFSET_DEFAULT, // This was extracted from the Shopify example (Dawn theme), it is hardcoded
  };
};
